import { __assign } from "tslib";
import React from 'react';
import { StyleSheet, View } from 'react-native';
// Custom
import c from '../styles/_colors.js';
import PnmacTextMobile from '../Typography/PnmacTextMobile';
var Bottom = function (props) {
  return /*#__PURE__*/React.createElement(View, {
    style: props.style
  }, /*#__PURE__*/React.createElement(PnmacTextMobile, {
    style: s.sectionFooter
  }, props.label));
};
var PnmacSection = function (props) {
  var realChildren = React.Children.toArray(props.children);
  var children = realChildren.map(function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, {
      last: index === realChildren.length - 1
    });
  });
  return /*#__PURE__*/React.createElement(View, {
    style: [s.container, props.style]
  }, props.label > "" && /*#__PURE__*/React.createElement(Title, __assign({}, props)), children.length > 0 && /*#__PURE__*/React.createElement(View, {
    style: [s.sectionContent(props), props.innerStyle]
  }, children));
};
var Title = function (props) {
  return /*#__PURE__*/React.createElement(View, {
    style: s.sectionLabel(props)
  }, /*#__PURE__*/React.createElement(PnmacTextMobile, {
    style: [s.sectionLabelText(props), props.boldLabel ? s.boldLabelText : {}]
  }, props.label));
};
var Row = function (props) {
  return /*#__PURE__*/React.createElement(View, {
    style: [s.row(props), props.style]
  }, props.children);
};
var Separator = function (props) {
  return /*#__PURE__*/React.createElement(View, {
    style: s.sectionSeparator(props)
  });
};
var TopHeader = function (props) {
  return /*#__PURE__*/React.createElement(View, {
    style: s.topHeader(props)
  });
};
PnmacSection.Bottom = Bottom;
PnmacSection.Row = Row;
PnmacSection.Title = Title;
PnmacSection.Separator = Separator;
PnmacSection.TopHeader = TopHeader;
export default PnmacSection;
var s = {
  sectionLabel: function (props) {
    return {
      backgroundColor: props.withBg ? c.white : 'transparent',
      borderBottomColor: c.lighterGray,
      borderBottomWidth: props.children ? StyleSheet.hairlineWidth : 0,
      paddingHorizontal: 20,
      paddingVertical: 7
    };
  },
  sectionLabelText: function (props) {
    return {
      fontSize: 13
    };
  },
  boldLabelText: {
    fontSize: 14,
    color: c.darkerGray,
    fontFamily: 'opensans-bold'
  },
  sectionFooter: {
    fontSize: 12,
    marginHorizontal: 20,
    marginBottom: 7
  },
  sectionContent: function (props) {
    return {
      backgroundColor: props.static ? 'transparent' : c.white,
      borderTopColor: c.lighterGray,
      borderBottomColor: c.lighterGray,
      borderTopWidth: props.label > "" ? 0 : StyleSheet.hairlineWidth,
      borderBottomWidth: StyleSheet.hairlineWidth
    };
  },
  row: function (props) {
    return {
      backgroundColor: c.white,
      borderBottomColor: '#DBDBDB',
      borderBottomWidth: props.last ? 0 : 0.5
    };
  },
  sectionSeparator: function (props) {
    return {
      height: 30
    };
  },
  topHeader: function (props) {
    return {
      height: 20
    };
  }
};